import { Injector, NgModule } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LocalCommonModule } from './common.module';
import { AuthCallbackComponent } from './Components/account/auth-callback/auth-callback.component';
import { SilentCallbackComponent } from './Components/account/auth-callback/silent-callback.component';
import { actConfirmComponent } from './Components/account/confirm/actConfirm.component';
import { emailConfirmComponent } from './Components/account/confirm/emailConfirm.component';
import { LogInErrorPopUpComponent } from './Components/PopUps/LogInErrorPopUpComponent';
import { ScannerPopUpComponent } from './Components/PopUps/ScannerPopUpComponent';
import { HeaderComponent } from './Components/shell/header/header.component';
import { SettingsShellComponent } from './Components/shell/SettingsShellComponent';
import { SideMenuComponent } from './Components/shell/SideMenuComponent';
import { StorageShellComponent } from './Components/shell/StorageShellComponent';
import { setAppInjector } from './Services/AppInjector';
import { ConfigService } from './Services/ConfigService';
import { AuthService } from './RoutingAuth/auth.service';
import { ToastsContainer } from './Directives/toastsDisplay';
import { SupportCallbackComponent } from './Components/account/auth-callback/support-callback.component';
import { ReportsShellComponent } from './Components/shell/ReportsShellComponent';
import { ViewerComponent } from './Components/3rdParty/ViewerComponent';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

@NgModule({
	imports: [
		BrowserAnimationsModule,
		LocalCommonModule.forRoot(),
		AppRoutingModule,
		NgxExtendedPdfViewerModule
	],
	exports: [
		BrowserAnimationsModule,
	],
	declarations: [
		AppComponent,
		AuthCallbackComponent,
		SilentCallbackComponent,
		SupportCallbackComponent,
		HeaderComponent,
		ToastsContainer,
		ScannerPopUpComponent,
		emailConfirmComponent,
		actConfirmComponent,
		LogInErrorPopUpComponent,
		ReportsShellComponent,
		SettingsShellComponent,
		StorageShellComponent,
		SideMenuComponent,
		ViewerComponent
	],
	bootstrap: [
		AppComponent
	],
	providers: [
		ConfigService,
		AuthService,
	]
})
export class AppModule {
	constructor(injector: Injector) {
		setAppInjector(injector);
	}
}
